import React from 'react'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import Button from 'Components/button'
import Avatar from 'Components/author/avatar'
import Stars from 'Components/stars'
import formatNumber from '@arsenal/arsenal/modules/formatNumber'
import { getKeyByValue } from '../../tabMapping'
import FilterBackground from 'Components/new/filter-background'
import styles from './index.module.scss'
import classNames from 'classnames'

const dongchefen = require('static/dong-che-fen.svg')
const yellow_star_little = require('static/yellow-star-little.png')
const black_star_little = require('static/black-star-little.png')
interface ICommunityHeaderProps {
  cheyouHead: any
  cheyouSeriesReviewCard: any
  series_id: string
  currentTab?: string
  joined_days?: string
  isJoining?: boolean
  handleJoinClick: (e: React.MouseEvent) => void
}

const CommunityHeader = ({
  cheyouHead,
  cheyouSeriesReviewCard,
  series_id,
  currentTab,
  joined_days,
  isJoining,
  handleJoinClick,
}: ICommunityHeaderProps) => {
  const list = [
    {
      name: '车友',
      value: formatNumber(cheyouHead?.user_amount),
      filter: (value?: string) => !!value,
    },
    {
      name: '认证车主',
      value: formatNumber(cheyouHead?.certified_owner_count),
      filter: (value?: string) => !!value,
    },
    {
      name: '问答',
      value: formatNumber(cheyouHead?.wenda_count),
      filter: (value?: string) => !!value,
    },
    {
      name: '口碑',
      value: formatNumber(cheyouHead?.kou_bei_count),
      filter: (value?: string) => !!value && cheyouHead?.community_type === 0,
    },
  ].filter((d) => d.filter(d.value))

  return (
    <>
      <FilterBackground
        src={cheyouHead?.background_url}
        alt={`${cheyouHead?.name || ''}封面`}
        style={{ margin: '0 4%' }}
        className="tw-rounded-2 tw-overflow-hidden"
      >
        <div
          style={{ height: '309px' }}
          className={classNames(
            styles.content,
            'tw-w-full tw-h-full 2xl:tw-px-60 tw-p-36 tw-flex tw-justify-between tw-text-12 md:tw-text-14 tw-relative'
          )}
        >
          <div className={classNames(styles['content-left'], 'tw-w-5/10')}>
            <h1 className="line-1 tw-h-34 tw-text-20 md:tw-text-24 tw-text-common-white tw-font-medium">
              {cheyouHead?.series_name
                ? `${cheyouHead?.series_name}车友圈`
                : cheyouHead?.name}
            </h1>
            <p className="line-2 tw-mt-6  tw-text-14 md:tw-text-16 tw-h-auto">
              {cheyouHead?.description}
            </p>
            <div className="tw-mt-22 tw-h-44 tw-flex tw-items-center">
              {cheyouHead?.master_avatar && (
                <a
                  className={classNames(styles.user, 'tw-flex tw-items-center')}
                  target="_blank"
                  href={`/user/${cheyouHead?.master_avatar?.avatar_user_id_str}`}
                  title={`${cheyouHead?.master_avatar?.avatar_user_name}个人主页`}
                  onClick={() =>
                    sendTeaCommEvent('clk_event', {
                      page_id: 'page_ugc_forum_home',
                      event_id: 'join_forum_home_user',
                      car_series_id: String(series_id),
                      car_series_name: cheyouHead?.name,
                      motor_id: cheyouHead?.motor_id_str,
                      sub_tab: getKeyByValue(currentTab as any),
                    })
                  }
                >
                  <Avatar
                    size={40}
                    avatar={cheyouHead?.master_avatar?.avatar_url}
                    userVerified={
                      !!cheyouHead?.master_avatar?.motor_auth_show_info
                        ?.auth_v_type
                    }
                    verifyType={
                      cheyouHead?.master_avatar?.motor_auth_show_info
                        ?.auth_v_type
                    }
                  />

                  <p className="tw-ml-6 tw-text-common-white  tw-font-semibold line-1">
                    圈主：{cheyouHead?.master_avatar?.avatar_user_name}
                  </p>
                  <div className={styles.line} />
                </a>
              )}

              {cheyouHead?.user_avatar_list?.map((item: any, index: number) => {
                return (
                  <a
                    key={index}
                    target="_blank"
                    title={`${item?.avatar_user_name}个人主页`}
                    href={`/user/${item?.avatar_user_id_str}`}
                    onClick={() =>
                      sendTeaCommEvent('clk_event', {
                        page_id: 'page_ugc_forum_home',
                        event_id: 'join_forum_home_user',
                        car_series_id: String(series_id),
                        car_series_name: cheyouHead?.name,
                        motor_id: cheyouHead?.motor_id_str,
                        sub_tab: getKeyByValue(currentTab as any),
                      })
                    }
                  >
                    <Avatar
                      size={20}
                      avatar={item?.avatar_url}
                      key={index}
                      userVerified={!!item?.motor_auth_show_info?.auth_v_type}
                      verifyType={item?.motor_auth_show_info?.auth_v_type}
                    />
                  </a>
                )
              })}

              <p className="tw-ml-6 line-1 tw-text-color-gray-700">
                共{formatNumber(cheyouHead?.user_amount)}车友等你加入
              </p>
            </div>
            <div className="tw-mt-10 tw-h-22 tw-flex tw-items-center ">
              {list.map((item, index) => {
                return (
                  <div key={index} className="tw-mr-20 tw-flex tw-items-center">
                    <p>{item.name}：</p>
                    <p
                      className={classNames(
                        styles.value,
                        'tw-text-common-white tw-font-medium'
                      )}
                    >
                      {item.value}
                    </p>
                  </div>
                )
              })}
            </div>
            <div className="tw-flex tw-items-center tw-mt-24 tw-text-14">
              <Button
                loading={isJoining}
                type="new_primary"
                onClick={handleJoinClick}
                style={{
                  height: '28px',
                  lineHeight: '28px',
                  backgroundColor: joined_days ? '#E6E6E6 ' : '#FFCC33',
                }}
                className="tw-w-160"
              >
                {joined_days ? `已加入${joined_days}天` : '加入圈子'}
              </Button>
              {cheyouHead?.community_type === 0 && (
                <a
                  role="button"
                  href={`/auto/series/${series_id}`}
                  target="_blank"
                  className="tw-text-common-white tw-ml-12 tw-w-72 tw-rounded-2 tw-border tw-border-solid tw-border-gray-600 tw-h-28 tw-flex tw-items-center tw-justify-center"
                  onClick={() =>
                    sendTeaCommEvent('clk_event', {
                      page_id: 'page_ugc_forum_home',
                      event_id: 'look_car_entrance',
                      car_series_id: String(series_id),
                      car_series_name: cheyouHead?.name,
                      motor_id: cheyouHead?.motor_id_str,
                      sub_tab: getKeyByValue(currentTab as any),
                      obj_text: '看车',
                    })
                  }
                >
                  看车
                </a>
              )}
              {/* <button
              type="button"
              className=" tw-text-common-white tw-w-72 tw-ml-12 tw-h-32 tw-rounded-2 tw-border tw-border-solid tw-border-gray-600"
            >
              认证车主
            </button> */}
            </div>
            {/* </div> */}
          </div>
          {!!cheyouSeriesReviewCard?.review_people_count && (
            <div
              className={classNames(
                styles['content-right'],
                'tw-w-5/10 tw-h-full tw-p-12 tw-flex tw-flex-col tw-text-12'
              )}
              onClick={() => {
                sendTeaCommEvent('clk_event', {
                  page_id: 'page_ugc_forum_home',
                  event_id: 'top_dcd_score_card_entrance',
                  car_series_id: String(cheyouSeriesReviewCard?.series_id),
                  car_series_name: cheyouSeriesReviewCard?.series_name,
                  module_id: 'forum_home_top_dcd_score_module',
                })
              }}
            >
              <div className="tw-flex tw-h-18 tw-justify-between">
                <img src={dongchefen} height={18} width={48} />
                <p>共{cheyouSeriesReviewCard?.review_people_count}人评价</p>
              </div>
              <div className="tw-flex tw-h-46 tw-mt-6 tw-items-center ">
                {cheyouSeriesReviewCard?.score ? (
                  <p
                    className={classNames(
                      styles.value,
                      'tw-text-yellow-400 tw-font-medium tw-flex tw-items-center  tw-text-36'
                    )}
                  >
                    {Number(cheyouSeriesReviewCard?.score / 100).toFixed(2)}
                  </p>
                ) : (
                  <p
                    className={classNames(
                      styles.value,
                      'tw-text-yellow-400 tw-font-medium tw-flex tw-items-center  tw-text-12 tw-mr-21'
                    )}
                  >
                    暂无评分
                  </p>
                )}
                <div className="tw-ml-6">
                  <Stars
                    starIcon={yellow_star_little}
                    starVacantIcon={black_star_little}
                    score={Number(
                      (cheyouSeriesReviewCard?.score / 100).toFixed(2)
                    )}
                    maxScore={5}
                    starWidth={13}
                    starHeight={11}
                  />
                  {cheyouSeriesReviewCard?.score_description && (
                    <p className="md:tw-text-14 tw-text-color-gray-400">
                      “{cheyouSeriesReviewCard?.score_description}”
                    </p>
                  )}
                </div>
              </div>

              <a
                className="tw-flex tw-mt-6 tw-items-center"
                target="_blank"
                href={`/auto/series/score/${series_id}-x-x-x-x-x`}
              >
                查看详情
                <i className={`DCD_Icon icon_PC-triangle`} />
              </a>
            </div>
          )}
        </div>
      </FilterBackground>
    </>
  )
}
export default CommunityHeader
